import { Box, Chip, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import ToolIntegrationLogos from "../../../components/ToolIntegrationLogos";
import { useEmployeeTerminology } from "../../../utils/terminology";

interface BrowseToolsBannerProps {
  onClick: () => void;
}

export default function BrowseToolsBanner({ onClick }: BrowseToolsBannerProps) {
  const { employee: employeeText } = useEmployeeTerminology();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        mb: 2,
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : "center",
        justifyContent: "space-between",
        gap: isMobile ? 1.5 : 0,
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
          borderColor: "primary.main",
          boxShadow: 1,
        },
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          gap: isMobile ? 1.5 : 2,
        }}
      >
        <ToolIntegrationLogos />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              900+ {employeeText} Tool Integrations Available
            </Typography>
          <Typography variant="body2" color="text.secondary">
            Connect Gmail, Slack, HubSpot, Salesforce, and hundreds more
          </Typography>
        </Box>
      </Box>
      <Chip
        label="Beta"
        size="small"
        sx={{ alignSelf: isMobile ? "flex-end" : "center" }}
      />
    </Paper>
  );
}
